import React, { useState , useEffect} from 'react';
import $ from 'jquery';
import Swal from 'sweetalert2'
import { BsArrowRightCircleFill } from "react-icons/bs";
import contact1 from '../Image/contact1.avif'
function Contact_page() {
  useEffect(()=>{
    document.title='Contact | InternsElite';
  },[]);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    text: '',
  });

  const [nameError, setNameError] = useState(" "); 
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [textError, setTextError] = useState("");


  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === 'fullName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setNameError(`Invalid name format.`);
      }  
      else {
        setNameError("");
      }
    }
    
    if (name === 'email') {
      if (!value || !/\S+@\S+\.\S+/.test(value)) {
        setEmailError("Invalid email format");
      } else {
        setEmailError("");
      }
    
    }

    if (name === 'mobileNo') {
      if (!value || !/^\d{10}$/.test(value)) {
        setPhoneError("Length Should be 10 Digit");
      } else {
        setPhoneError("");
      }
    }
    if (name === 'text') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setTextError(`Invalid Text format.`);
      }  
      else {
        setTextError("");
      }
    }
   
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async(event) => {
    event.preventDefault();
      $.ajax({
        url: 'https://forms.internselite.net/contactform',
        type: 'POST',
        data: { fullName: $('[name="fullName"]').val(),
        mobileNo: $('[name="mobileNo"]').val(),
        email: $('[name="email"]').val(),
        text: $('[name="text"]').val()
         },
        success: function (response) {
          Swal.fire({
            title: "Form Submitted!",
            text: "What's next? Our team will review your submission and get back to you with in 24 hours.",
            icon: "success"
          });
            $('[name="text"]').val('');
            $('[name="fullName"]').val('');
            $('[name="mobileNo"]').val('');
            $('[name="email"]').val('');
        },
        error: function (error) {
          console.error('Error:', error);
        }
    });
    
  };
  return (
    <div>
      {/* -----------------------Mobile View------------------------ */}
    <div>
    <div className='Mobile_Contact_us_background_image d-sm-block d-md-none mt-5'>
        <div className='container-fluid mobile_Contact_background_color pt-4'>
            <div className='text-center mobile_About_Main_text py-5'>
                <h1 className='display-2 text-white'>Contact US</h1>
                <h3 className='text-white fs-5 pt-1'>Empower your learning journey by reaching out.</h3>
            </div>
        </div>
    </div>
    <div className='container d-sm-block d-md-none'>
    <div className='Mobile_BDA_background_element d-sm-block d-md-none pb-5 pt-4'>
      <div className='col-md-12'>
          <div className='mobile_contact_text'>
              <h1 className='display-6 text-center'>Connect To Excel</h1>
              <h3 className='pt-2 text-center'>For a seamless Education Journey.</h3>
              <p className='pt-1 text-center pb-2'>Unlock the future of education! Reach out for inquiries, enrollment details, and personalized counselling. Let's shape your learning journey together with advanced technology and support.</p>
              <div><img className='contact_img' src={contact1}></img></div>
          </div>
      </div>
      <div className='mt-3  pb-4'>
      <div className='py-4 px-3 BDA_form_text shadow-lg'>
          <div className='text-center border-bottom pb-2'>
          <span>Contact Us...</span>
          </div>
          <div className=''>
          <form onSubmit={handleSubmit}>
              <div class="mt-4">
              <label for="fullName" class="form-label pb-2 fw-bold contact_form">Full Name</label>
              <input
              className='py-2 form-control'
              type="text"
              id="fullName"
              name="fullName"
              placeholder="Your answer"
              value={formData.fullName}
              onChange={handleInputChange}
              required
              />
              {nameError && <div className="error text-danger">{nameError}</div>}
              </div>
              <div class="mt-3">
              <label for="email" class="form-label pb-2 fw-bold contact_form">Email Address</label>
              <input
              className='py-2 form-control'
              type="email"
              id="email"
              name="email"
              placeholder="Your answer"
              value={formData.email}
              onChange={handleInputChange}
              required
              />
              {emailError && <div className="error text-danger">{emailError}</div>}
              </div>
              <div class="mt-3">
              <label for="mobileNo" class="form-label pb-2 fw-bold contact_form">Phone Number</label>
              <input
              className='py-2 form-control'
              type="tel"
              id="mobileNo"
              name="mobileNo"
              placeholder="Your answer"
              value={formData.mobileNo}
              onChange={handleInputChange}
              required
              />
              {phoneError && <div className="error text-danger">{phoneError}</div>}
              </div>
              <div class="mb-3">
              <label for="text" class="form-label mt-3 pb-2 fw-bold contact_form ">Query</label>
              <textarea
              rows="3"
              className='py-2 form-control'
              type="text"
              id="text"
              name="text"
              placeholder="Your answer"
              value={formData.text}
              onChange={handleInputChange}
              required
              />
              {textError && <div className="error text-danger">{textError}</div>}
              </div>
              <div className='row mt-2 pt-2'>
                  <div className='d-flex justify-content-center'>
                  <button className="text-white shadow-sm  fs-5 px-5 pt-1 pb-2 Navbar_button">Submit</button>
                  </div>
              </div>
              </form>
          </div>
      </div>
      </div>
    </div>
    </div>
    </div>

    {/* -------------------Desktop View------------------------- */}
    <div>
    <div className='Contact_us_background_image d-none d-md-block mt-5 pb-3'>
        <div className='container-fluid Contact_background_color pt-5'>
            <div className='text-center pt-5 Contact_Main_text'>
                <h1 className='display-2 text-white'>Contact US</h1>
                <h3 className='text-white display-5 pt-4 '>Empower your learning journey by reaching out.</h3>
            </div>
        </div>
    </div>
    <div className='container d-none d-md-block pb-4'>
    <div className='BDA_background_element d-none d-md-block  mt-4'>
        <div className='container py-4'>
            <div className='row'>
                <div className='col-md-7 px-2 pt-3'>
                    <div className='BDA_text'>
                        <h1 className='display-6'>Connect To Excel</h1>
                        <h2 className='py-2'>For a seamless Education Journey.</h2>
                        <p className='py-3 '>Unlock the future of education! Reach out for inquiries, enrollment details, and personalized counselling. Let's shape your learning journey together with advanced technology and support.</p>
                        <div><img className='contact_img pt-5' src={contact1}></img></div>
                    </div>
                </div>
                <div className='col-md-5 BDA_form_text shadow-lg px-5 pb-4'>
                <div className='mt-4'>
                    <span className=''>Contact Us...</span>
                    <div className=''>
                    <form onSubmit={handleSubmit}>
                        <div class="mt-4">
                        <label for="fullName" class="form-label pb-2 fw-bold contact_form">Full Name</label>
                        <input
                        className='py-2 form-control'
                        type="text"
                        id="fullName"
                        name="fullName"
                        placeholder="Your answer"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        required
                        />
                        {nameError && <div className="error text-danger">{nameError}</div>}
                        </div>
                        <div class="mt-3">
                        <label for="email" class="form-label pb-2 fw-bold contact_form">Email Address</label>
                        <input
                        className='py-2 form-control'
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Your answer"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        />
                        {emailError && <div className="error text-danger">{emailError}</div>}
                        </div>
                        <div class="mt-3">
                        <label for="mobileNo" class="form-label pb-2 fw-bold contact_form">Phone Number</label>
                        <input
                        className='py-2 form-control'
                        type="tel"
                        id="mobileNo"
                        name="mobileNo"
                        placeholder="Your answer"
                        value={formData.mobileNo}
                        onChange={handleInputChange}
                        required
                        />
                        {phoneError && <div className="error text-danger">{phoneError}</div>}
                        </div>
                        <div class="mb-3">
                        <label for="text" class="form-label mt-3 pb-2 fw-bold contact_form ">Query</label>
                        <textarea
                        rows="3"
                        className='py-2 form-control'
                        type="text"
                        id="text"
                        name="text"
                        placeholder="Your answer"
                        value={formData.text}
                        onChange={handleInputChange}
                        required
                        />
                        {textError && <div className="error text-danger">{textError}</div>}
                        </div>
                        <div className='row mt-2 pt-4'>
                            <div className='d-flex justify-content-center'>
                            <button className="text-white shadow-sm  fs-5 px-5 pt-1 pb-2 Navbar_button">Submit</button>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </div>
    </div>
    {/* <div className='d-none d-md-block'>
    <iframe className='w-100' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.202925444482!2d77.04124057502575!3d28.413133144010956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x83376897e758e91b%3A0x198189118ca0998b!2sInternsElite%20Edutech%20Private%20Limited!5e0!3m2!1sen!2sin!4v1695194964515!5m2!1sen!2sin" width="70%" height="200"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
    </iframe>
    </div> */}
    </div>
    </div>
  )
}

export default Contact_page
